import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";
import {MenuItem, Select} from "@mui/material";
import {KeyboardArrowDown} from "@mui/icons-material";

const SelectSitePrepTemplateModal = observer(() => {
    const {modalStore, generalStore, projectStore} = useStores();

    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const renderBody = () => {
        return (
            <Select
                variant="outlined"
                className='site-prep-template-select'
                value={selectedTemplate?.ProcedureName || ""}
                MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    }
                }}
                IconComponent={KeyboardArrowDown}
            >
                {[...projectStore.sitePrepTemplates.values()].map((template, i) =>
                    <MenuItem key={i} value={template.ProcedureName} onClick={() => setSelectedTemplate(template)}>
                        {template.ProcedureName}
                    </MenuItem>
                )}
            </Select>
        )
    }

    const onEnter = () => {
        const templateId = modalStore.modalData.sitePrepData?.templateId;
        const currentTemplate = templateId ? projectStore.sitePrepTemplates.get(templateId) || null : null;
        setSelectedTemplate(currentTemplate);
    }

    const onConfirm = async () => {
        modalStore.modalData.sitePrepData.templateId = selectedTemplate.TemplateIdentifier;
        modalStore.isSelectSitePrepTemplateModalOpen = false;
        modalStore.isAddSitePrepUsersModalOpen = true;
    }

    return (
        <GeneralDialog
            openControl='isSelectSitePrepTemplateModalOpen'
            className={'procedure-option-dialog site-prep-options'}
            title={generalStore.translate('chooseTemplate')}
            body={renderBody()}
            onEnter={onEnter}
            noCancel
            isConfirmDisabled={!selectedTemplate}
            confirmText={generalStore.translate('next')}
            onConfirm={onConfirm}
            extraClose
            goBackControl={'isSetSitePrepNameModalOpen'}
        />
    );
});

export default SelectSitePrepTemplateModal;
